///////////////////////////////////////////////////////
/// ABERTURA DA INSERÇÃO DOS COMPONENTS DGP GLOBAIS ///
///////////////////////////////////////////////////////
import ModosWebRepeaterComponent from '@/common/modosweb-components/ModosWebRepeaterComponent';

export default {
    install (Vue) {
      Vue.component('ModosWebRepeaterComponent', ModosWebRepeaterComponent)
  }
}